export default __webpack_public_path__ + "static/media/spreadLove.b4284dca.svg";